import { createSlice } from '@reduxjs/toolkit';

const initialState = {
  allOrders: [],
  orders: [],
  offers: [],
  suggestions: [],
  isFirstLoad: true
};

const myOrdersSlice = createSlice({
  name: 'myOrders',
  initialState,
  reducers: {
    setAllOrders: (state, action) => {
      state.allOrders = action.payload;
    },
    setOrders: (state, action) => {
      state.orders = action.payload;
    },
    setOffers: (state, action) => {
      state.offers = action.payload;
    },
    setSuggestions: (state, action) => {
      state.suggestions = action.payload;
    },
    initializeFirstLoad: (state, action) => {
      // Mark that initial load is complete
      state.isFirstLoad = false;
    },
    resetMyOrders: (state) => {
      return initialState;
    }
  },
});

export const {
  setAllOrders,
  setOrders,
  setOffers,
  setSuggestions,
  initializeFirstLoad,
  resetMyOrders
} = myOrdersSlice.actions;

export default myOrdersSlice.reducer;
